import { scaleLinear, scaleLog } from 'd3-scale';
export var legendRadius = [10, 25, 40];
export var opacityScale = function (domain, minOpacity) {
    return scaleLog().domain(domain).range([1, minOpacity]);
};
export var radiusScale = function (minRadius, maxRadius, maxRange) { return scaleLinear().domain([minRadius, maxRadius]).range([0, maxRange]); };
export var verticalPositionScale = function (maxRadius) {
    return scaleLinear()
        .domain([0, maxRadius])
        .range([0, maxRadius * 2]);
};
export var sortByValue = function (values) { return values.sort(function (a, b) { return a - b; }); };
export var isTruncated = function (el) {
    return el.scrollWidth > el.clientWidth;
};
